import { Topic, TopicGroup } from 'src/components/BeaconV2Components/ExperimentalLayout/Traffic/types';
import { UserMetaData } from 'src/serverProxy/userMetadataServerProxy';

/**
 * Data point for spline chart using weekId-based format
 */
export interface SplineDataPoint {
  weekId: number;
  value: number;
}

export interface TopicCardRecord {
  id: string;
  name: string;
  type: 'topic' | 'topicGroup';
  owner: UserMetaData;
  topicMetadata: Topic;
  topicGroups: TopicGroup[];
  ownership: 'Custom' | 'Standard' | 'Owned';
  /**
   * Spline data that goes on the card with the format
   * { weekId, value }
   */
  splineData: SplineDataPoint[];
  comparisonSplineData: SplineDataPoint[];
  totalTraffic: number;
  totalTrafficPercentChange: number;
}

export enum TopicType {
  All = 'All',
  Standard = 'Standard',
  Custom = 'Custom',
  Owned = 'Owned'
}

export enum TopicPillFilter {
  All = 'All',
  Topics = 'Topics',
  TopicGroups = 'Topic Groups'
}
